import { Button, Modal, Select } from 'antd';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useContaService } from '../../../services/conta.service';
import BaseInput from './base-input';
import BaseSelect from './base-select';
import BaseDatePicker from './base-date-picker';
import moment from 'moment';
import { IContaDTO, IDespesaFullDTO } from '../../../models/happy-code-api.model';
import { useGlobalContext } from '../../../context/GlobalContext';
import { useNotificationService } from '../../../services/notification.service';
import { useDespesaService } from '../../../services/despesa.service';
import Styles from './components.module.scss';

interface ModalEditProps {
	open: boolean;
	setOpen: Dispatch<SetStateAction<boolean>>;
	despesa: IDespesaFullDTO;
	refreshTable: () => void;
}

const EditParcelModal = ({ open, setOpen, despesa, refreshTable }: ModalEditProps) => {
	const [valor, setValor] = useState(despesa?.vlDespesa);
	const [conta, setConta] = useState(despesa?.conta?.id);
	const [vencimento, setVencimento] = useState(despesa?.dhVencimento);
	const [contas, setContas] = useState<IContaDTO[]>([]);
	const contaService = useContaService();
	const { setIsGlobalLoading } = useGlobalContext();
	const notification = useNotificationService();
	const despesaService = useDespesaService();

	const fetchContas = () => {
		setIsGlobalLoading(true);
		contaService.findList().then(({ data }) => {
			setContas(data);
		}).finally(() => setIsGlobalLoading(false));
	};

	const patchDespesa = async () => {
		const updatedDespesa = {
			id: despesa.id,
			vlDespesa: valor,
			dhVencimento: vencimento,
			conta: {
				id: conta,
			},
		};

		setIsGlobalLoading(true);
		despesaService
			.patch(updatedDespesa)
			.then(() => {
				notification({ description: 'Despesa alterada com sucesso!', type: 'success', message: 'Sucesso' });
				refreshTable();
			})
			.finally(() => {
				setIsGlobalLoading(false);
			});
	};

	useEffect(() => {
		if (open) {
			fetchContas();
		}
	}, [open]);

	const handleOk = async () => {
		await patchDespesa();
		setOpen(false);
	};
	const handleCancel = () => {
		setOpen(false);
	};

  useEffect(() => {
    if (open) {
      setValor(despesa?.vlDespesa);
      setConta(despesa?.conta?.id);
      setVencimento(despesa?.dhVencimento);
    }
  }, [open, despesa]);
  

	return (
		<Modal
			destroyOnClose
			visible={open}
			title="Editar Parcela"
			onCancel={handleCancel}
			footer={[
				<Button key="cancel" onClick={handleCancel}>
					Cancelar
				</Button>,
				<Button key="submit" type="primary" onClick={handleOk}>
					Confirmar
				</Button>,
			]}
			style={{ top: 20 }}
			width={600}
		>
			<div className={Styles.modalContainer}>
				<BaseSelect
					value={conta}
					onChange={(item) => setConta(item)}
					labelConfig={{
						label: 'Conta',
						tooltip: true,
						tooltipText: 'Selecione uma conta já cadastrada.',
					}}
					placeholder="Selecione"
					width={'60%'}
				>
					{contas.map((item) => (
						<Select.Option key={item.id} value={item.id}>
							{item.descricao}
						</Select.Option>
					))}
				</BaseSelect>

				<BaseInput
					min={0}
					value={valor}
					onChange={(e) => setValor(Number(e.target.value))}
					type="number"
					labelConfig={{
						label: 'Valor',
						tooltip: true,
						tooltipText: 'Valor da parcela.',
					}}
					placeholder="R$ 0,00"
					width={'60%'}
				/>

				<BaseDatePicker
					value={moment(vencimento)}
					onChange={(date) => setVencimento(date ? date.toDate() : undefined)}
					labelConfig={{
						label: 'Vencimento',
						tooltip: true,
						tooltipText: 'Data de vencimento da parcela.',
					}}
					placeholder="Selecione uma data"
					width={'60%'}
				/>
			</div>
		</Modal>
	);
};

export default EditParcelModal;
